module.exports = __webpack_public_path__ + "static/logo-box-2bec1e6d7ed5feb70a4f09a85fa1bbdd.png";